import React, { useEffect } from 'react';
import './CartProgressBar.scss';

const CartProgressBar = ({ addToBagText, cartfullIcon, handleCartProgressBar }: any) => {
  const cartlocalstorage = localStorage.getItem('cartProgressBar');
  useEffect(() => {
    if (cartlocalstorage) {
      localStorage.removeItem('cartProgressBar');
      handleCartProgressBar();
    }
  }, [cartlocalstorage]);

  return (
    <>
      {cartfullIcon && addToBagText && (
        <>
          <div className="textWrapper">
            <p className="textStyle" role="alert" aria-live="polite">
              {addToBagText}
            </p>
            <img src={cartfullIcon} alt="full bag icon" className="fullCartIcon" />
          </div>
          <div className="progressBarStyle">
            <div className="progressFillStyle"></div>
          </div>
        </>
      )}
    </>
  );
};

export default CartProgressBar;
